import { getAPIUrl } from "../config";

const API_URL = getAPIUrl()

export const fetchFloors = async (venueId, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Failed to fetch floors');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching floors:', error);
    throw error;
  }
};

export const addFloor = async (venueId, newFloor, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newFloor)
    });
    if (!response.ok) {
      throw new Error('Failed to add floor');
    }
    return await response.json();
  } catch (error) {
    console.error('Error adding floor:', error);
    throw error;
  }
};

export const updateFloor = async (venueId, updatedFloor, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors/${updatedFloor.id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedFloor)
    });
    if (!response.ok) {
      throw new Error('Failed to update floor');
    }
    return await response.json();
  } catch (error) {
    console.error('Error updating floor:', error);
    throw error;
  }
};

export const updateFloors = async (venueId, updatedFloors, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();

      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedFloors)
      });

      if (!response.ok) {
        throw new Error('Failed to update floors');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating floors:', error);
      throw error;
    }
  };

export const reorderFloors = async (venueId, floorsWithOrder, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors/reorder`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ floors: floorsWithOrder })
    });
    
    if (!response.ok) {
      throw new Error('Failed to reorder floors');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error reordering floors:', error);
    throw error;
  }
};

export const deleteFloor = async (venueId, floorId, getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/floors/${floorId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error('Failed to delete floor');
    }
  } catch (error) {
    console.error('Error deleting floor:', error);
    throw error;
  }
};
